import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '@lib/queryKeys';
import { fetchInventoryStockMovementSummary } from '@/renderer/services/inventoryStockMovementService';
import type { InventoryStockMovementFilterParams } from '@/renderer/types/inventory';

export function useInventoryStockMovementSummary(
  companyId: number | null | undefined,
  outletId: string | null | undefined,
  search: string,
  stockLocationId: InventoryStockMovementFilterParams['stockLocationId'],
  movementType: InventoryStockMovementFilterParams['movementType'],
  inventoryItemIds?: InventoryStockMovementFilterParams['inventoryItemIds'],
  dateFrom?: string,
  dateTo?: string,
) {
  const normalizedInventoryItemIds = inventoryItemIds ?? [];

  return useQuery({
    queryKey: queryKeys.inventory.stockMovementSummary(
      companyId ?? 0,
      outletId ?? '',
      search,
      stockLocationId ?? 'all',
      movementType ?? 'all',
      normalizedInventoryItemIds,
      dateFrom ?? '',
      dateTo ?? '',
    ),
    queryFn: async () => {
      const result = await fetchInventoryStockMovementSummary(
        companyId ?? 0,
        outletId ?? '',
        search,
        stockLocationId,
        movementType,
        normalizedInventoryItemIds,
        dateFrom,
        dateTo,
      );
      if (!result.success || !result.data) {
        throw new Error(
          result.error ?? 'Failed to fetch inventory stock movement summary',
        );
      }

      return result.data;
    },
    enabled: !!companyId && !!outletId,
  });
}
